import {
  STOCK_TAKING_CAR_MANAGEMENT_PAGINATED_LOAD
} from '../constants'

export function reducer(state, action) {
  if (action.type === STOCK_TAKING_CAR_MANAGEMENT_PAGINATED_LOAD) {
    return {
      ...state,
      takingCarManagement: {
        ...state.takingCarManagement,
        takingCarsPaginated: action.data
      }
    }
  } else {
    return state
  }
}